<div class="step-content row box-shadow-container mt-1 justify-content-end">
  <app-step-sidebar class="col-md-3 pt-md-2" [model]="model"></app-step-sidebar>
  <div class="topper"></div>
  <div class="col-md-9">
    <ng-content> </ng-content>
  </div>
</div>
@if (model) {
  <div class="btn-group d-lg-flex justify-content-end align-items-center">
    @if (model.buttons.back) {
      <div class="cancel-btn-container">
        @if (model.currentStepIdx > 0) {
          <button type="button" (click)="model.back()" class="btn btn-outline-secondary px-5" data-cy="back-btn">
            {{ model.backButtonText || 'Back' }}
          </button>
        }
      </div>
    }
    @if (model.buttons.continue) {
      <div>
        <button class="btn btn-primary px-5 ml-lg-5" (click)="handleNextStep()" type="submit" [disabled]="(model.currentForm ? model.currentForm.invalid : true) || model.submitDisabled || (isLoading$ | async)" data-cy="continue-btn">
          @if ((isLoading$ | async) === false) {
            <span>{{ model.currentStepIdx === model.stepViews.size - 1 ? 'Submit' : 'Save and Continue' }}</span>
          }
          @if (isLoading$ | async) {
            <span class="d-flex align-items-center">
              <mat-spinner [diameter]="20" class="mr-2" color="primary"></mat-spinner>
              <span>{{ model.currentStepIdx === model.stepViews.size - 1 ? 'Submitting...' : 'Saving...' }}</span>
            </span>
          }
        </button>
      </div>
    }
    @if (model.buttons.saveAndContinue) {
      <div>
        <button class="btn btn-primary px-5 ml-lg-5" (click)="handleSaveAndContinue()" type="submit" [disabled]="(model.currentForm ? model.currentForm.invalid : true) || (isLoading$ | async)" data-cy="save-and-continue-btn">
          @if ((isLoading$ | async) === false) {
            <span>Save and Continue Later</span>
          }
          @if (isLoading$ | async) {
            <span class="d-flex align-items-center">
              <mat-spinner [diameter]="20" class="mr-2" color="primary"></mat-spinner>
              <span>Saving...</span>
            </span>
          }
        </button>
      </div>
    }
  </div>
}
